module.exports = __webpack_public_path__ + "img/horizontal_7_1_3009.0f26d06e.png";